module.exports = __webpack_public_path__ + "static/media/response-recommendation.06007e42.svg";